import { Component, Input, OnInit, Output, EventEmitter, ViewChild, OnChanges, ViewEncapsulation, ViewChildren, QueryList } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { Campaign3Info, MessageInstanceRuleTypes, MessageInstanceObjectTypes, MessageInstanceObject, MessageInstanceRule, MessageInstanceRuleDetail } from 'app/views/campaign-3/models/campaign-3.model';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';
import { MessageService } from 'primeng/primeng';
import { Observable } from 'rxjs';



@Component({
  selector: 'app-message-3-products-target',
  templateUrl: './message-3-products-target.component.html',
  styleUrls: ['./message-3-products-target.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Message3ProductsTargetComponent implements OnInit {

  @Input() campaignInfo: Campaign3Info = null;
  @Input() ui_mode: string = this.srvCampaign3.ui_modes.CREATE;
  @Input() coupon_mode: string = this.srvCampaign3.coupon_modes.CREATE;
  @Input() miRuleTypesList: Array<MessageInstanceRuleTypes> = [];
  @Input() miObjectTypesList: Array<MessageInstanceObjectTypes> = [];
  @Input() listPaniereEmission: Array<any> = [];
  @Input() listDepartmentEmission: Array<any> = [];
  @Input() listCategoriesEmission: Array<any> = [];
  @Input() listProductsEmission: Array<any> = [];

  @Input() formSchema: any;
  @Input() readOnly: boolean = false;
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Input() messageInstanceObject: MessageInstanceObject;
  @Output() messageInstanceObjectChange: EventEmitter<MessageInstanceObject> = new EventEmitter<MessageInstanceObject>();


  filtersViewProducts: Array<{ key: string, value: string }> = [];
  PT_rules_emission: Array<MessageInstanceRule> = [];
  /*   PT_rules_fruition: Array<MessageInstanceRule> = []; */


  list = {
    emission: {
      products: [],
      departments: [],
      baskets: [],
      categories: []
    },

  }


  //  currentProductListToShow: Array<any> = [];

  valid: boolean = true;

  show = {
    form: false,
    modalPaniereEmissione: false,
    modalRepartoEmissione: false,
    modalCategoriaEmissione: false,
    modalArticoloEmissione: false,
    modalPaniereFruizione: false,
    modalRepartoFruizione: false,
    modalCategoriaFruizione: false,
    modalArticoloFruizione: false,
    modalViewProducts: false
  }

  //comboTipoEntitaEmissione: Array<{code: string, name: string}>
  //comboTipoEntitaFruizione: Array<{code: string, name: string}>

  fieldModel = {
    tipoEntitaEmissione: null,
    tipoEntitaFruizione: null
  }

  productsListEmissioneSelected: Array<any> = [];
  paniereListEmissioneSelected: Array<any> = [];
  departmentListEmissioneSelected: Array<any> = [];
  categoriesListEmissioneSelected: Array<any> = [];


  disablePlusEmissionType = true;

  /*   productsListFruizioneSelected: Array<any> = [];
    paniereListFruizioneSelected: Array<any> = [];
    departmentListFruizioneSelected: Array<any> = [];
    categoriesListFruizioneSelected: Array<any> = []; */

  title = {
    modalViewProduct: ""
  }

  constructor(
    private srvCampaign3: Campaign3Service,
    private srvCalTranslate: CalendarTranslateService,
    private srvNotify: MessageService,
    private translate: TranslateService
  ) {

  }
  ngOnInit() {
    console.log("formSchema", this.formSchema);

    // Copia dati iniziali emissione
    this.list.emission.products = JSON.parse(JSON.stringify(this.listProductsEmission));
    this.list.emission.departments = JSON.parse(JSON.stringify(this.listDepartmentEmission));
    this.list.emission.baskets = JSON.parse(JSON.stringify(this.listPaniereEmission));
    this.list.emission.categories = JSON.parse(JSON.stringify(this.listCategoriesEmission));

    this.truncBasketProductString();
    this.show.form = true;

    const ENTITIES = {
      DEPARTMENT: 'R', // Reparto
      PRODUCT: 'A',    // Articolo
      CATEGORY: 'C',   // Categoria
      BASKET: 'P'      // Paniere
    };

    const self = this;

    setTimeout(function () {
      if (self.messageInstanceObject && self.ui_mode === self.srvCampaign3.ui_modes.EDIT) {

        // Reset liste emissione
        self.departmentListEmissioneSelected = [];
        self.productsListEmissioneSelected = [];
        self.categoriesListEmissioneSelected = [];
        self.paniereListEmissioneSelected = [];

        // --- Step 1: raccogliere tutti gli ID per emissione ---
        const emissionIds = { departments: [], products: [], categories: [], baskets: [] };

        self.messageInstanceObject.messageInstanceRule.forEach(mir => {
          if (mir.ruleTypeId !== self.miRuleTypesList.find(x => x.code === "PT").id) return;
          if (mir.ruleScope !== self.srvCampaign3.ruleScopesEmissionFruition.EMISSION) return;

          mir.messageInstanceRuleDetail.forEach(mird => {
            const typeDep = self.miObjectTypesList.find(x => x.code === "TDEP");
            const typePrd = self.miObjectTypesList.find(x => x.code === "TPRD");
            const typeCat = self.miObjectTypesList.find(x => x.code === "TCAT");
            const typeBsk = self.miObjectTypesList.find(x => x.code === "TBSK");

            if (typeDep && mird.objectTypeId === typeDep.id) emissionIds.departments.push(mird.objectId);
            else if (typePrd && mird.objectTypeId === typePrd.id) emissionIds.products.push(mird.objectId);
            else if (typeCat && mird.objectTypeId === typeCat.id) emissionIds.categories.push(mird.objectId);
            else if (typeBsk && mird.objectTypeId === typeBsk.id) emissionIds.baskets.push(mird.objectId);
          });
        });

        // --- Step 2: chiamate API parallele solo per emissione ---
        Observable.zip(
          self.srvCampaign3.getDepartmentsByIds(emissionIds.departments),
          self.srvCampaign3.getProductsByIds(emissionIds.products),
          self.srvCampaign3.getCategoriesByIds(emissionIds.categories),
          self.srvCampaign3.getBasketsByIds(emissionIds.baskets)
        ).subscribe(([depEm, prodEm, catEm, bskEm]: any) => {

          console.log('--- Emission Data ---');
          console.log('Departments Emission:', depEm);
          console.log('Products Emission:', prodEm);
          console.log('Categories Emission:', catEm);
          console.log('Baskets Emission:', bskEm);

          // Popolamento selezioni e tipo entità usando solo i dati API
          self.messageInstanceObject.messageInstanceRule.forEach(mir => {
            if (mir.ruleTypeId !== self.miRuleTypesList.find(x => x.code === "PT").id) return;
            if (mir.ruleScope !== self.srvCampaign3.ruleScopesEmissionFruition.EMISSION) return;

            mir.messageInstanceRuleDetail.forEach(mird => {
              let tipoEntita = null;

              if (mird.objectTypeId === self.miObjectTypesList.find(x => x.code === "TDEP").id) {
                let dep = depEm.data.find(x => x.id === mird.objectId);
                if (dep) {
                  dep["rowSelected"] = true;
                  dep["inclusione_esclusione"] = mird.objectInclude === self.srvCampaign3.ruleIncludeExclude.INCLUDE ? "I" : (mird.objectInclude === self.srvCampaign3.ruleIncludeExclude.EXCLUDE ? "E" : null);
                  if (!self.departmentListEmissioneSelected.find(x => x.id === dep.id)) self.departmentListEmissioneSelected.push(dep);
                  tipoEntita = ENTITIES.DEPARTMENT;
                } else console.log("Reparto non trovato!");
              } else if (mird.objectTypeId === self.miObjectTypesList.find(x => x.code === "TPRD").id) {
                let prod = prodEm.data.find(x => x.id === mird.objectId);
                if (prod) {
                  prod["rowSelected"] = true;
                  prod["inclusione_esclusione"] = mird.objectInclude === self.srvCampaign3.ruleIncludeExclude.INCLUDE ? "I" : (mird.objectInclude === self.srvCampaign3.ruleIncludeExclude.EXCLUDE ? "E" : null);
                  if (!self.productsListEmissioneSelected.find(x => x.id === prod.id)) self.productsListEmissioneSelected.push(prod);
                  tipoEntita = ENTITIES.PRODUCT;
                } else console.log("Prodotto non trovato!");
              } else if (mird.objectTypeId === self.miObjectTypesList.find(x => x.code === "TCAT").id) {
                let cat = catEm.data.find(x => x.id === mird.objectId);
                if (cat) {
                  cat["rowSelected"] = true;
                  cat["inclusione_esclusione"] = mird.objectInclude === self.srvCampaign3.ruleIncludeExclude.INCLUDE ? "I" : (mird.objectInclude === self.srvCampaign3.ruleIncludeExclude.EXCLUDE ? "E" : null);
                  if (!self.categoriesListEmissioneSelected.find(x => x.id === cat.id)) self.categoriesListEmissioneSelected.push(cat);
                  tipoEntita = ENTITIES.CATEGORY;
                } else console.log("Categoria non trovata!");
              } else if (mird.objectTypeId === self.miObjectTypesList.find(x => x.code === "TBSK").id) {
                let bsk = bskEm.data.find(x => x.basketId === mird.objectId);
                if (bsk) {
                  bsk["rowSelected"] = true;
                  bsk["inclusione_esclusione"] = mird.objectInclude === self.srvCampaign3.ruleIncludeExclude.INCLUDE ? "I" : (mird.objectInclude === self.srvCampaign3.ruleIncludeExclude.EXCLUDE ? "E" : null);
                  if (!self.paniereListEmissioneSelected.find(x => x.basketId === bsk.basketId)) self.paniereListEmissioneSelected.push(bsk);
                  tipoEntita = ENTITIES.BASKET;
                } else console.log("Paniere non trovato!");
              }

              const tipoEntitaEmissioneItem = self.formSchema.form.tipo_entita_emissione.options.find(item => item.value === tipoEntita);
              if (tipoEntitaEmissioneItem) {
                self.fieldModel.tipoEntitaEmissione = {
                  value: tipoEntitaEmissioneItem.value,
                  label: tipoEntitaEmissioneItem.label[self.language]
                };
              }
              self.disablePlusEmissionType = self.fieldModel.tipoEntitaEmissione !== "T" ? false : true;
            });
          });
        });
      }
    }, 100);

    // Controllo sull'attivazione del plus in emissione se non è totale cassa o nullo
    if (this.formSchema.form.tipo_entita_emissione.default !== "T" && this.formSchema.form.tipo_entita_emissione.default != null) {
      this.disablePlusEmissionType = false;
    }
  }

  truncBasketProductString() {
    for (let pan of this.list.emission.baskets) {
      pan.articoli = pan.articoli.substring(0, 100) + "...";
    }
    /*  for(let pan of this.list.fruition.baskets){
       pan.articoli = pan.articoli.substring(0,100) + "...";
     } */
  }
  onClickAnnulla_ModalViewProducts() {
    this.show.modalViewProducts = false;
    // this.currentProductListToShow = [];
    this.filtersViewProducts = [];
  }
  onChangeTipoEntitaEmissione(tipoEntitaEmissione: any) {
    if (tipoEntitaEmissione.value != "T") {
      this.disablePlusEmissionType = false;
    } else {
      this.disablePlusEmissionType = true;
    }
  }


  onClickAddEntitaEmissione() {
    //- se non c'è soglia emissione non posso inserire articoli/panieri/categorie/reparti in emissione (mail 05/06/2024)
    let rule_SOGLIA = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "CV").id);
    if (!rule_SOGLIA) {
      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('campaign.emission_threshold_not_set'),
        life: 5000
      });

      return;
    }
    else {
      let mir_PTRE = rule_SOGLIA.messageInstanceRuleDetail.find(x => x.objectTypeId == this.miObjectTypesList.find(x => x.code == "PTRE").id);
      if (!mir_PTRE) {
        this.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.emission_threshold_not_set'),
          life: 5000
        });
        return;
      }
    }

    if (this.fieldModel.tipoEntitaEmissione) {
      if (this.fieldModel.tipoEntitaEmissione.value == "P") {
        this.show.modalPaniereEmissione = true;
      }
      else if (this.fieldModel.tipoEntitaEmissione.value == "R") {
        this.show.modalRepartoEmissione = true;
      }
      else if (this.fieldModel.tipoEntitaEmissione.value == "C") {
        this.show.modalCategoriaEmissione = true;
      }
      else if (this.fieldModel.tipoEntitaEmissione.value == "A") {
        //this.resetAllSeletcedEmissionProducts();
        this.show.modalArticoloEmissione = true;
      }
    }
  }
  onClickAddEntitaFruizione() {

    if (this.fieldModel.tipoEntitaFruizione) {
      if (this.fieldModel.tipoEntitaFruizione.value == "P") {
        this.show.modalPaniereFruizione = true;
      }
      else if (this.fieldModel.tipoEntitaFruizione.value == "R") {
        this.show.modalRepartoFruizione = true;
      }
      else if (this.fieldModel.tipoEntitaFruizione.value == "C") {
        this.show.modalCategoriaFruizione = true;
      }
      else if (this.fieldModel.tipoEntitaFruizione.value == "A") {
        this.show.modalArticoloFruizione = true;
      }
    }
  }
  onCategoriesCancelEmissione() {
    this.show.modalCategoriaEmissione = false;
  }
  onCategoriesCancelFruizione() {
    this.show.modalCategoriaFruizione = false;
  }
  performValidationProductsTarget(): boolean {

    this.valid = true;
    const validateSelection = (
      tipoEntita: any,
      paniereList: any[],
      categoriesList: any[],
      productsList: any[],
      departmentList: any[]
    ): boolean => {
      if (tipoEntita && tipoEntita.value != "T"
        && paniereList.length === 0
        && categoriesList.length === 0
        && productsList.length === 0
        && departmentList.length === 0) {

        this.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.add_item_redeem_list'),
          life: 5000
        });
        return false;
      }
      return true;
    };


    // Validazione per Emissione
    if (!validateSelection(
      this.fieldModel.tipoEntitaEmissione,
      this.paniereListEmissioneSelected,
      this.categoriesListEmissioneSelected,
      this.productsListEmissioneSelected,
      this.departmentListEmissioneSelected
    )) {
      this.valid = false;
    }


    for (let item of this.departmentListEmissioneSelected) {
      item.valid = true;
      if (item.inclusione_esclusione != "I" && item.inclusione_esclusione != "E") {
        item.valid = false;
        this.valid = false;
      }
    }
    for (let item of this.categoriesListEmissioneSelected) {
      item.valid = true;
      if (item.inclusione_esclusione != "I" && item.inclusione_esclusione != "E") {
        item.valid = false;
        this.valid = false;
      }
    }
    for (let item of this.paniereListEmissioneSelected) {
      item.valid = true;
      if (item.inclusione_esclusione != "I" && item.inclusione_esclusione != "E") {
        item.valid = false;
        this.valid = false;
      }
    }
    for (let item of this.productsListEmissioneSelected) {
      item.valid = true;
      if (item.inclusione_esclusione != "I" && item.inclusione_esclusione != "E") {
        item.valid = false;
        this.valid = false;
      }
    }

    /*     for(let item of this.departmentListFruizioneSelected){
          item.valid = true;
          if(item.inclusione_esclusione!="I" && item.inclusione_esclusione!="E"){
            item.valid = false;
            this.valid = false;
          }
        }
        for(let item of this.categoriesListFruizioneSelected){
          item.valid = true;
          if(item.inclusione_esclusione!="I" && item.inclusione_esclusione!="E"){
            item.valid = false;
            this.valid = false;
          }
        }
        for(let item of this.paniereListFruizioneSelected){
          item.valid = true;
          if(item.inclusione_esclusione!="I" && item.inclusione_esclusione!="E"){
            item.valid = false;
            this.valid = false;
          }
        }
        for(let item of this.productsListFruizioneSelected){
          item.valid = true;
          if(item.inclusione_esclusione!="I" && item.inclusione_esclusione!="E"){
            item.valid = false;
            this.valid = false;
          }
        } */

    return this.valid;
  }
  /*** EMISSIONE */
/*   onProductsSelectedEmissione(products: Array<any>) {
    //quì ho tutti gli elementi visualizzati in tabella con rowSelected a true o false
    this.show.modalArticoloEmissione = false;

    this.productsListEmissioneSelected = [];

    if (products && products.length > 0) {
      for (let pr of products) {
        pr["inclusione_esclusione"] = null;
        pr["valid"] = false;
        this.productsListEmissioneSelected.push(Object.assign({}, pr));
      }
    }
  } */

  onProductsSelectedEmissione(products: Array<any>) {
  this.show.modalArticoloEmissione = false;

  if (!products || products.length === 0) {
    this.productsListEmissioneSelected = [];
    return;
  }

  const oldList = this.productsListEmissioneSelected;

  this.productsListEmissioneSelected = products
    .filter(pr => pr.rowSelected) // tengo solo quelli selezionati
    .map(pr => {
      const existing = oldList.find(x => x.id === pr.id);
      return existing
        ? existing // se già presente, mantieni inclusione_esclusione e valid
        : { ...pr, inclusione_esclusione: null, valid: false }; // nuovo, inizializza
    });
}

  onPaniereSelectedEmissione(panieri: Array<any>) {

    //quì ho tutti gli elementi visualizzati in tabella con rowSelected a true o false
    this.show.modalPaniereEmissione = false;

    this.paniereListEmissioneSelected = [];

    if (panieri && panieri.length > 0) {
      for (let pan of panieri) {
        pan["inclusione_esclusione"] = null;
        pan["valid"] = false;
        this.paniereListEmissioneSelected.push(Object.assign({}, pan));
      }
    }
  }
  onDepartmentSelectedEmissione(reparti: Array<any>) {
    //quì ho tutti gli elementi visualizzati in tabella con rowSelected a true o false
    this.show.modalRepartoEmissione = false;

    this.departmentListEmissioneSelected = [];

    if (reparti && reparti.length > 0) {
      for (let dep of reparti) {
        dep["inclusione_esclusione"] = null;
        dep["valid"] = false;
        this.departmentListEmissioneSelected.push(Object.assign({}, dep));
      }
    }
  }
  onCategoriesSelectedEmissione(categories: Array<any>) {
    //quì ho tutti gli elementi visualizzati in tabella con rowSelected a true o false
    this.show.modalCategoriaEmissione = false;

    this.categoriesListEmissioneSelected = [];

    if (categories && categories.length > 0) {
      for (let cat of categories) {
        cat["inclusione_esclusione"] = null;
        cat["valid"] = false;
        this.categoriesListEmissioneSelected.push(Object.assign({}, cat));
      }
    }
  }
  onProductsCancelEmissione() {
    this.show.modalArticoloEmissione = false;
  }
  onPaniereCancelEmissione() {
    this.show.modalPaniereEmissione = false;
  }
  onDepartmentCancelEmissione() {
    this.show.modalRepartoEmissione = false;
  }
  onClickDelEmissione(type: string, index: number) {
    if (type == "A") {
      let found = this.list.emission.products.find(x => x.id == this.productsListEmissioneSelected[index].id);
      if (found)
        found["rowSelected"] = false;
      this.productsListEmissioneSelected.splice(index, 1);
    }
    else if (type == "P") {
      let found = this.list.emission.baskets.find(x => x.basketId == this.paniereListEmissioneSelected[index].basketId);
      if (found)
        found["rowSelected"] = false;
      this.paniereListEmissioneSelected.splice(index, 1);
    }
    else if (type == "C") {
      let found = this.list.emission.categories.find(x => x.id == this.categoriesListEmissioneSelected[index].id);
      if (found)
        found["rowSelected"] = false;
      this.categoriesListEmissioneSelected.splice(index, 1);
    }
    else if (type == "R") {
      let found = this.list.emission.departments.find(x => x.id == this.departmentListEmissioneSelected[index].id);
      if (found)
        found["rowSelected"] = false;
      this.departmentListEmissioneSelected.splice(index, 1);
    }
  }
  onClickShowEmission(type: string, index: number) {
    if (type == "P") {
      let basketId: string = this.paniereListEmissioneSelected[index].basketId;
      this.title.modalViewProduct = "Paniere " + this.paniereListEmissioneSelected[index].description;
      this.filtersViewProducts = [{ key: "basket_id", value: basketId }];
      this.show.modalViewProducts = true;
    }
    else if (type == "R") {
      let departmentId: string = this.departmentListEmissioneSelected[index].id;
      this.title.modalViewProduct = "Reparto " + this.departmentListEmissioneSelected[index].code;
      this.filtersViewProducts = [{ key: "product_department_id", value: departmentId }];
      this.show.modalViewProducts = true;
    }
    else if (type == "C") {
      let categoryId: string = this.categoriesListEmissioneSelected[index].id;
      this.title.modalViewProduct = "Categoria " + this.categoriesListEmissioneSelected[index].code + "-" + this.categoriesListEmissioneSelected[index].description;
      this.filtersViewProducts = [{ key: "product_category_id", value: categoryId }];
      this.show.modalViewProducts = true;
    }
    /*
    else if(type == "A"){
      let productId: string = this.productsListEmissioneSelected[index].id;
      this.title.modalViewProduct = "Articolo " + this.productsListEmissioneSelected[index].description;
      this.filtersViewProducts = [{key: "product_item_id", value: productId}];
      this.show.modalViewProducts = true;
    } 
    */
  }
  onClickInclusioneEmissione(type: string, index: number) {
    if (!this.readOnly) {
      if (type == "A") {
        this.productsListEmissioneSelected[index]["inclusione_esclusione"] = "I";
        this.productsListEmissioneSelected[index].valid = true;
      }
      else if (type == "P") {
        this.paniereListEmissioneSelected[index]["inclusione_esclusione"] = "I";
        this.paniereListEmissioneSelected[index].valid = true;
      }
      else if (type == "C") {
        this.categoriesListEmissioneSelected[index]["inclusione_esclusione"] = "I";
        this.categoriesListEmissioneSelected[index].valid = true;
      }
      else if (type == "R") {
        this.departmentListEmissioneSelected[index]["inclusione_esclusione"] = "I";
        this.departmentListEmissioneSelected[index].valid = true;
      }
    }
  }
  onClickEsclusioneEmissione(type: string, index: number) {
    if (!this.readOnly) {
      if (type == "A") {
        this.productsListEmissioneSelected[index]["inclusione_esclusione"] = "E";
        this.productsListEmissioneSelected[index].valid = true;
      }
      else if (type == "P") {
        this.paniereListEmissioneSelected[index]["inclusione_esclusione"] = "E";
        this.paniereListEmissioneSelected[index].valid = true;
      }
      else if (type == "C") {
        this.categoriesListEmissioneSelected[index]["inclusione_esclusione"] = "E";
        this.categoriesListEmissioneSelected[index].valid = true;
      }
      else if (type == "R") {
        this.departmentListEmissioneSelected[index]["inclusione_esclusione"] = "E";
        this.departmentListEmissioneSelected[index].valid = true;
      }
    }
  }

  /*** FRUIZIONE ***/
  /* onProductsSelectedFruizione(products: Array<any>){
  
    //quì ho tutti gli elementi visualizzati in tabella con rowSelected a true o false
    this.show.modalArticoloFruizione = false;
    
    this.productsListFruizioneSelected = [];
  
    if(products && products.length>0) {
      for(let pr of products){
        let foundIndex = this.productsListFruizioneSelected.findIndex(x=>x.id == pr.id);
        if(foundIndex>-1 && pr.rowSelected==false){
          this.productsListFruizioneSelected.splice(foundIndex,1);
        }
        else if(foundIndex==-1 && pr.rowSelected==true){
          pr["inclusione_esclusione"] = null;
          pr["valid"]=false;
          this.productsListFruizioneSelected.push(Object.assign({},pr));
        }
      }
    }
  }
  onPaniereSelectedFruizione(panieri: Array<any>){
  
    //quì ho tutti gli elementi visualizzati in tabella con rowSelected a true o false
    this.show.modalPaniereFruizione = false;
      
    this.paniereListFruizioneSelected = [];
  
    if(panieri && panieri.length>0) {
      for(let pan of panieri){
        pan["inclusione_esclusione"] = null;
        pan["valid"]=false;
        this.paniereListFruizioneSelected.push(Object.assign({},pan));
      }
    }
      
  }
  onCategoriesSelectedFruizione(categories: Array<any>){
    //quì ho tutti gli elementi visualizzati in tabella con rowSelected a true o false
    this.show.modalCategoriaFruizione = false;
      
    this.categoriesListFruizioneSelected = [];
  
    if(categories && categories.length>0) {
      for(let cat of categories){
        cat["inclusione_esclusione"] = null;
        cat["valid"]=false;
        this.categoriesListFruizioneSelected.push(Object.assign({},cat));
      }
    }
  }
  onDepartmentSelectedFruizione(reparti: Array<any>){
    //quì ho tutti gli elementi visualizzati in tabella con rowSelected a true o false
    this.show.modalRepartoFruizione = false;
      
    this.departmentListFruizioneSelected = [];
  
    if(reparti && reparti.length>0) {
      for(let dep of reparti){
        dep["inclusione_esclusione"] = null;
        dep["valid"]=false;
        this.departmentListFruizioneSelected.push(Object.assign({},dep));
      }
    }
  } */
  onProductsCancelFruizione() {
    this.show.modalArticoloFruizione = false;
  }
  onPaniereCancelFruizione() {
    this.show.modalPaniereFruizione = false;
  }
  onDepartmentCancelFruizione() {
    this.show.modalRepartoFruizione = false;
  }
  /* onClickDelFruizione(type: string,index:number){
    if(type == "A"){
      let found = this.list.fruition.products.find(x=>x.id == this.productsListFruizioneSelected[index].id);
      if(found)
        found["rowSelected"]=false;
      this.productsListFruizioneSelected.splice(index,1);
    }
    else if(type == "P"){
      let found = this.list.fruition.baskets.find(x=>x.basketId == this.paniereListFruizioneSelected[index].basketId);
      if(found)
        found["rowSelected"]=false;
      this.paniereListFruizioneSelected.splice(index,1);
    }
    else if(type == "C"){
      let found = this.list.fruition.categories.find(x=>x.id == this.categoriesListFruizioneSelected[index].id);
      if(found)
        found["rowSelected"]=false;
      this.categoriesListFruizioneSelected.splice(index,1);
    }
    else if(type == "R"){
      let found = this.list.fruition.departments.find(x=>x.id == this.departmentListFruizioneSelected[index].id);
      if(found)
        found["rowSelected"]=false;
      this.departmentListFruizioneSelected.splice(index,1);
    }
  } */
  /* onClickShowFruition(type: string,index:number){
   
    if(type == "P"){
      let basketId: string = this.paniereListFruizioneSelected[index].basketId;
      //ATTENZIONE: quì dovrei filtrare i prodotti per il basketId, ma non è possibile attualmente;
    //  this.currentProductListToShow = this.productsListFruizioneSelected.filter(x=>x.department_code == )
    }
    else if(type == "R"){
      let departmentCode: string = this.departmentListFruizioneSelected[index].code;
     // this.currentProductListToShow = this.listProductsFruition.filter(x=>x.department_code == departmentCode);
      this.title.modalViewProduct = "Reparto " + this.departmentListFruizioneSelected[index].code;
      this.show.modalViewProducts = true;
    } 
  } */
  /* onClickInclusioneFruizione(type: string,index:number){
    if(!this.readOnly){
      if(type == "A"){
        this.productsListFruizioneSelected[index]["inclusione_esclusione"]="I";
        this.productsListFruizioneSelected[index].valid = true;
      }
      else if(type == "P"){
        this.paniereListFruizioneSelected[index]["inclusione_esclusione"]="I";
        this.paniereListFruizioneSelected[index].valid = true;
      }
      else if(type == "C"){
        this.categoriesListFruizioneSelected[index]["inclusione_esclusione"]="I";
        this.categoriesListFruizioneSelected[index].valid = true;
      }
      else if(type == "R"){
        this.departmentListFruizioneSelected[index]["inclusione_esclusione"]="I";
        this.departmentListFruizioneSelected[index].valid = true;
      }
    }
  }
  onClickEsclusioneFruizione(type: string,index:number){
    if(!this.readOnly){
      if(type == "A"){
        this.productsListFruizioneSelected[index]["inclusione_esclusione"]="E";
        this.productsListFruizioneSelected[index].valid = true;
      }
      else if(type == "P"){
        this.paniereListFruizioneSelected[index]["inclusione_esclusione"]="E";
        this.paniereListFruizioneSelected[index].valid = true;
      }
      else if(type == "C"){
        this.categoriesListFruizioneSelected[index]["inclusione_esclusione"]="E";
        this.categoriesListFruizioneSelected[index].valid = true;
      }
      else if(type == "R"){
        this.departmentListFruizioneSelected[index]["inclusione_esclusione"]="E";
        this.departmentListFruizioneSelected[index].valid = true;
      }
    }
  } */
  onNewBasket(isNewBasketCreated) {
    if (isNewBasketCreated == true) {
      this.srvNotify.add({
        severity: 'success',
        summary: this.translate.instant('common.success'),
        detail: this.translate.instant('campaign.new_basket_created')
      });
    } else {
      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('campaign.error_creating_basket')
      });
    }

    this.show.modalPaniereEmissione = false;
    this.show.modalPaniereFruizione = false;
  }
  createRules() {

    this.PT_rules_emission = [];
    /* this.PT_rules_fruition = []; */

    if (
      (this.departmentListEmissioneSelected && this.departmentListEmissioneSelected.length > 0) ||
      (this.categoriesListEmissioneSelected && this.categoriesListEmissioneSelected.length > 0) ||
      (this.productsListEmissioneSelected && this.productsListEmissioneSelected.length > 0) ||
      (this.paniereListEmissioneSelected && this.paniereListEmissioneSelected.length > 0)) {
      let rule = new MessageInstanceRule();
      rule.messageInstanceId = this.messageInstanceObject.id;
      rule.ruleTypeId = this.miRuleTypesList.find(x => x.code == "PT").id;
      rule.ruleType = "PT";
      rule.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
      rule.ruleScope = this.srvCampaign3.ruleScopesEmissionFruition.EMISSION;

      if (this.departmentListEmissioneSelected.length > 0) {
        for (let dep of this.departmentListEmissioneSelected) {
          let mird = new MessageInstanceRuleDetail();
          mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TDEP").id;
          mird.objectTypeCode = "TDEP";
          mird.objectId = dep.id;
          mird.objectInclude = dep["inclusione_esclusione"] == "I" ? this.srvCampaign3.ruleIncludeExclude.INCLUDE : (dep["inclusione_esclusione"] == "E" ? this.srvCampaign3.ruleIncludeExclude.EXCLUDE : null);
          rule.messageInstanceRuleDetail.push(mird);
        }
      }
      if (this.productsListEmissioneSelected.length > 0) {
        for (let prod of this.productsListEmissioneSelected) {
          let mird = new MessageInstanceRuleDetail();
          mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TPRD").id;
          mird.objectTypeCode = "TPRD";
          mird.objectId = prod.id;
          mird.objectInclude = prod["inclusione_esclusione"] == "I" ? this.srvCampaign3.ruleIncludeExclude.INCLUDE : (prod["inclusione_esclusione"] == "E" ? this.srvCampaign3.ruleIncludeExclude.EXCLUDE : null);
          rule.messageInstanceRuleDetail.push(mird);
        }
      }
      if (this.categoriesListEmissioneSelected.length > 0) {
        for (let cat of this.categoriesListEmissioneSelected) {
          let mird = new MessageInstanceRuleDetail();
          mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TCAT").id;
          mird.objectTypeCode = "TCAT";
          mird.objectId = cat.id;
          mird.objectInclude = cat["inclusione_esclusione"] == "I" ? this.srvCampaign3.ruleIncludeExclude.INCLUDE : (cat["inclusione_esclusione"] == "E" ? this.srvCampaign3.ruleIncludeExclude.EXCLUDE : null);
          rule.messageInstanceRuleDetail.push(mird);
        }
      }
      if (this.paniereListEmissioneSelected.length > 0) {
        for (let pan of this.paniereListEmissioneSelected) {
          let mird = new MessageInstanceRuleDetail();
          mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TBSK").id;
          mird.objectTypeCode = "TBSK";
          mird.objectId = pan.basketId;
          mird.objectInclude = pan["inclusione_esclusione"] == "I" ? this.srvCampaign3.ruleIncludeExclude.INCLUDE : (pan["inclusione_esclusione"] == "E" ? this.srvCampaign3.ruleIncludeExclude.EXCLUDE : null);
          rule.messageInstanceRuleDetail.push(mird);
        }
      }
      this.PT_rules_emission.push(rule);
    }

    /*   if(
        (this.departmentListFruizioneSelected && this.departmentListFruizioneSelected.length > 0) || 
        (this.categoriesListFruizioneSelected && this.categoriesListFruizioneSelected.length> 0) || 
        (this.productsListFruizioneSelected && this.productsListFruizioneSelected.length>0) || 
        (this.paniereListFruizioneSelected && this.paniereListFruizioneSelected.length>0))
        {
          let rule = new MessageInstanceRule();
          rule.messageInstanceId = this.messageInstanceObject.id;
          rule.ruleTypeId = this.miRuleTypesList.find(x=>x.code == "PT").id;
          rule.ruleType = "PT";
          rule.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
          rule.ruleScope = this.srvCampaign3.ruleScopesEmissionFruition.FRUITION;
    
          if(this.departmentListFruizioneSelected.length>0){
            for(let dep of this.departmentListFruizioneSelected){
              let mird = new MessageInstanceRuleDetail();
              mird.objectTypeId = this.miObjectTypesList.find(x=>x.code == "TDEP").id;
              mird.objectTypeCode = "TDEP";
              mird.objectId = dep.id;
              mird.objectInclude = dep["inclusione_esclusione"]== "I" ? this.srvCampaign3.ruleIncludeExclude.INCLUDE : (dep["inclusione_esclusione"]== "E" ? this.srvCampaign3.ruleIncludeExclude.EXCLUDE : null);
              rule.messageInstanceRuleDetail.push(mird);
            }
          }
          if(this.productsListFruizioneSelected.length>0){
            for(let prod of this.productsListFruizioneSelected){
              let mird = new MessageInstanceRuleDetail();
              mird.objectTypeId = this.miObjectTypesList.find(x=>x.code == "TPRD").id;
              mird.objectTypeCode = "TPRD";
              mird.objectId = prod.product_id;
              mird.objectInclude = prod["inclusione_esclusione"]== "I" ? this.srvCampaign3.ruleIncludeExclude.INCLUDE : (prod["inclusione_esclusione"]== "E" ? this.srvCampaign3.ruleIncludeExclude.EXCLUDE : null);
              rule.messageInstanceRuleDetail.push(mird);
            }
          }
          if(this.categoriesListFruizioneSelected.length>0){
            for(let cat of this.categoriesListFruizioneSelected){
              let mird = new MessageInstanceRuleDetail();
              mird.objectTypeId = this.miObjectTypesList.find(x=>x.code == "TCAT").id;
              mird.objectTypeCode = "TCAT";
              mird.objectId = cat.id;
              mird.objectInclude = cat["inclusione_esclusione"]== "I" ? this.srvCampaign3.ruleIncludeExclude.INCLUDE : (cat["inclusione_esclusione"]== "E" ? this.srvCampaign3.ruleIncludeExclude.EXCLUDE : null);
              rule.messageInstanceRuleDetail.push(mird);
            }
          }
          if(this.paniereListFruizioneSelected.length>0){
            for(let pan of this.paniereListFruizioneSelected){
              let mird = new MessageInstanceRuleDetail();
              mird.objectTypeId = this.miObjectTypesList.find(x=>x.code == "TBSK").id;
              mird.objectTypeCode = "TBSK";
              mird.objectId = pan.basketId;
              mird.objectInclude = pan["inclusione_esclusione"]== "I" ? this.srvCampaign3.ruleIncludeExclude.INCLUDE : (pan["inclusione_esclusione"]== "E" ? this.srvCampaign3.ruleIncludeExclude.EXCLUDE : null);
              rule.messageInstanceRuleDetail.push(mird);
            }
          }
          this.PT_rules_fruition.push(rule);
      } */

  }


}



// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-products-target/message-3-products-target.component.ts